module.exports = __webpack_public_path__ + "img/extract.449d6b17.png";